import { render, staticRenderFns } from "./PrioritySelect.vue?vue&type=template&id=c444c018&scoped=true"
import script from "./PrioritySelect.vue?vue&type=script&lang=js"
export * from "./PrioritySelect.vue?vue&type=script&lang=js"
import style0 from "./PrioritySelect.vue?vue&type=style&index=0&id=c444c018&prod&lang=sass&scoped=true"
import style1 from "./PrioritySelect.vue?vue&type=style&index=1&id=c444c018&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c444c018",
  null
  
)

export default component.exports